module.exports = __webpack_public_path__ + "img/united-kingdom.2b2db74e.svg";